import Decimal from 'decimal.js';
import { PaymentReceivedAmountSearchOption } from './payment-received-amount-search-option';

export class PaymentReceivedAmountSearchRule {

    constructor(
        public value: Decimal | null,
        public minValue: Decimal | null,
        public maxValue: Decimal | null,
        public option: PaymentReceivedAmountSearchOption
    ){}
}
